import React, { useEffect, useState } from "react";
import "./index.css";
import { Avatar, Button, IconButton, useMediaQuery } from "@mui/material";
import toast from "react-hot-toast";

import {
  Edit,
  KeyboardArrowDown,
  LockOpen,
  LockReset,
  Menu,
  NotificationAdd,
  NotificationsOff,
} from "@mui/icons-material";

import LockResetIcon from "@mui/icons-material/LockReset";

import ListItemIcon from "@mui/material/ListItemIcon";
import Logout from "@mui/icons-material/Logout";
import { Link, useNavigate } from "react-router-dom";
import { MenuOpen } from "@mui/icons-material";
import DropdownMenu from "../../Atoms/DropdownMenu";
import UserChangePassword from "../../../Views/Login/ChangePassword";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserRequest,
  getUserResponseClear,
} from "../../../Redux/GetUser/GetUserActions";
import { DEFAULTS, MODULES, ROLE_BY_PERMISSIONS } from "../../../Constant";
import { hasPermission } from "../../../Utils/getters";
import AvailableStatus from "../../Atoms/AvailableStatus";
import moment from "moment/moment";

const Header = ({ handleDrawerOpen, handleDrawerClose, nav }) => {
  const dispatch = useDispatch();
  const { getUserResponse } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const isMatches = useMediaQuery("(max-width:991px)");
  const handleLogout = () => {
    window.localStorage.removeItem("token");
    dispatch(getUserResponseClear());
    navigate("/login");
    toast.success("User logged out successfully");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [CurruserChangePassword, setCurrUserChangePassword] = useState({
    mount: false,
    id: undefined,
    name: "",
  });

  const handleChangePasswordClose = () => {
    setCurrUserChangePassword({ mount: false, id: "", name: "" });
  };

  const handleChangePasswordOpen = (mount, id, name) => {
    setCurrUserChangePassword({ mount, id, name });
  };

  const time_zone =
    getUserResponse?.data?.settings?.time_zone || DEFAULTS.TIME_ZONE;

  const date_format =
    getUserResponse?.data?.settings?.date_format || DEFAULTS.DATE_TIME_FORMAT;

  const [formattedDate, setFormattedDate] = useState("");
  const [formattedTime, setFormattedTime] = useState("");
  const [formattedDay, setFormattedDay] = useState("");

  function getDateAndTime() {
    const now = moment().tz(time_zone);
    setFormattedDay(now.format("dddd"));
    setFormattedDate(now.format(date_format));
    setFormattedTime(now.format("hh:mm:ss A"));
  }

  const id = setInterval(() => {
    intervel();
  }, 1000);

  const intervel = () => {
    getDateAndTime();
    clearInterval(id);
  };

  return (
    <div className="layout_header">
      {isMatches && (
        <IconButton
          color="primary"
          size="small"
          onClick={() => (nav ? handleDrawerClose() : handleDrawerOpen())}
        >
          {nav ? <MenuOpen fontSize="small" /> : <Menu fontSize="small" />}
        </IconButton>
      )}

      <div className="d-flex-juscon-sb-align-center">
        <div className="details-container mt-3">
          <div className="d-flex gap-2">
            <p className="primary-para">Date</p>
            <p>:</p>
            <p className="mb-10">
              {formattedDate} - {formattedDay}
            </p>
          </div>
          <div className="d-flex gap-2">
            <p className="primary-para">Time</p>
            <p>:</p>
            <p className="mb-10">{formattedTime}</p>
          </div>
        </div>
        <DropdownMenu
          MenuClassName="prflDrop"
          menuList={[
            ...(hasPermission(
              [ROLE_BY_PERMISSIONS[MODULES.EMPLOYEE].CHANGE_PASSWORD_EMPLOYEE],
              getUserResponse?.data
            )
              ? [
                  {
                    label: (
                      <>
                        <ListItemIcon>
                          <LockResetIcon />
                        </ListItemIcon>
                        Update Password
                      </>
                    ),

                    onClick: () => handleChangePasswordOpen(true),
                  },
                ]
              : []),

            {
              label: (
                <>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </>
              ),
              onClick: () => handleLogout(),
            },
          ]}
        >
          <Button className="acntDropBtn" color="inherit">
            <Avatar sx={{ width: 35, height: 35, fontSize: "small" }}>
              {getUserResponse?.data?.first_name
                ? getUserResponse.data.first_name.charAt(0)
                : ""}
            </Avatar>

            <div className="d-flex flex-dir-column">
              <div className="acntNmInfo mb-1">
                <p>
                  {getUserResponse?.data?.employee_id +
                    " - " +
                    getUserResponse?.data?.first_name}
                </p>
              </div>
              <div className="min-w-20">
                <AvailableStatus
                  status={
                    getUserResponse?.data?.is_super_admin
                      ? "SUPER ADMIN"
                      : getUserResponse?.data?.role?.name
                  }
                  customCls={
                    getUserResponse?.data?.is_super_admin
                      ? "index-red"
                      : "index-orange-mild"
                  }
                />
              </div>
            </div>
            <span className="material-symbols-rounded">expand_more</span>
          </Button>
        </DropdownMenu>
      </div>
      <UserChangePassword
        open={CurruserChangePassword.mount}
        title={
          <div className="d-flex align-items-center">
            Change Password {CurruserChangePassword.name}
          </div>
        }
        id={CurruserChangePassword.id}
        handleClose={handleChangePasswordClose}
      />
    </div>
  );
};

export default Header;
